export default __webpack_public_path__ + "static/banner-6ec0e3df1a74b7aa896529835e4ef8ce.png";